import React from "react";
import 'react-datepicker/dist/react-datepicker.css'

//https://reactdatepicker.com/

export default function SelectDateWeex({style, value, onChange, label = null, light = false}){
  // const [isOpen, setIsOpen] = useState(false);
  // const handleChange = (e) => {
  //   setIsOpen(!isOpen);
  //   onChange(e);
  // };
  // const handleClick = (e) => {
  //   e.preventDefault();
  //   setIsOpen(!isOpen);
  // };

  return (
    <div style={{position: "relative", width: "-webkit-fill-available", ...style}}>
      {label && <label style={{
        color: "var(--white)",
        position: "absolute",
        top: -8,
        zIndex: 1,
        left: 10,
        background: light? "var(--darkgray)": "var(--background)",
        paddingLeft: 3,
        paddingRight: 3
      }}>{label}</label>}
      <input type={"date"} value={value && !isNaN(new Date(value)) && new Date(value).toISOString().split('T')[0]}
             onChange={(e) => onChange(e.target.value)} style={{width: "-webkit-fill-available"}}/>
      {/*<ButtonWeex className="example-custom-input" onClick={handleClick}>*/}
      {/*  {value.toLocaleDateString('de-DE')}*/}
      {/*</ButtonWeex>*/}
      {/*{isOpen && (*/}
      {/*  <DatePicker selected={value} onChange={handleChange} inline/>*/}
      {/*)}*/}
    </div>
  );
}